import o from "./DarkModeToggle.vue2.js";
import a from "../../_virtual/_plugin-vue_export-helper.js";
const t = /* @__PURE__ */ a(o, [["__scopeId", "data-v-a468e6dd"]]);
export {
  t as default
};
